import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ShiftEntityModel} from "../shift-entity.model";
import {ChangeDetectorRef, Component, ViewChild} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {FormGroup} from "@angular/forms";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-shift-edit-page",
    templateUrl: "./shift-edit-page.component.html",
    providers: [provideEntityModel(ShiftEntityModel)]
})

export class ShiftEditPageComponent extends AbstractEditPage {
    @ViewChild("breaksEditGridComponent") breaksEditGridComponent: EditGridComponent;

    constructor(public model: ShiftEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    employeeSelected(employee): void {
        this.model.data.recUser.firstName = employee.firstName;
        this.model.data.recUser.lastName = employee.lastName;
    }

    shiftStartDateChanged(value: any): void {
        this.updateValueAndValidity(["startTime"]);
        this.breaksEditGridComponent.revalidate();
    }

    shiftStartTimeChanged(value: any): void {
        this.updateValueAndValidity(["startDate"]);
        this.breaksEditGridComponent.revalidate();
    }

    shiftFinishDateChanged(value: any): void {
        this.updateValueAndValidity(["startDate", "startTime"]);
        this.breaksEditGridComponent.revalidate();
    }

    shiftFinishTimeChanged(value: any): void {
        this.updateValueAndValidity(["startDate", "startTime"]);
        this.breaksEditGridComponent.revalidate();
    }

    breakStartDateChanged({value, dataItem, formGroup}: { value: any, dataItem: any, formGroup: FormGroup }): void {
        dataItem.startDate = value;
        formGroup.get("startTime").updateValueAndValidity();
    }

    breakStartTimeChanged({value, dataItem, formGroup}: { value: any, dataItem: any, formGroup: FormGroup }): void {
        dataItem.startTime = value;
        formGroup.get("startDate").updateValueAndValidity();
    }

    breakFinishDateChanged({value, dataItem, formGroup}: { value: any, dataItem: any, formGroup: FormGroup }): void {
        dataItem.finishDate = value;
        formGroup.get("finishTime").updateValueAndValidity();
        formGroup.get("startDate").updateValueAndValidity();
        formGroup.get("startTime").updateValueAndValidity();
    }

    breakFinishTimeChanged({value, dataItem, formGroup}: { value: any, dataItem: any, formGroup: FormGroup }): void {
        dataItem.finishTime = value;
        formGroup.get("finishDate").updateValueAndValidity();
        formGroup.get("startDate").updateValueAndValidity();
        formGroup.get("startTime").updateValueAndValidity();
    }
}
